import connection from '@/api/connection'

export const outputdetailsByLote = async ({ commit }, lote) => {
  commit('setOutputdetailIsSelecting', true);
  await connection.get(`/outputdetails/lote/${lote}`)
    .then(res => {
      const data = removeDuplicateInObject(res.data.data, 'productId');
      commit('setSelectedListOutputdetail', data);
      commit('setOutputdetailIsSelecting', false);
    }).catch(err => {
      console.log('error', err);
      commit('setOutputdetailIsSelecting', false);
    });
}

const removeDuplicateInObject = (array, property) => {
  const uniqueIds = [];

  const unique = array.filter(element => {
    const isDuplicate = uniqueIds.includes(element[property]);

    if (!isDuplicate) {
      uniqueIds.push(element[property]);

      return true;
    }

    return false;
  });

  return unique;
}

export const outputdetailById = async ({ commit }, id) => {
  commit('setOutputdetailIsLoading', true);
  await connection.get(`/outputdetails/${id}`)
    .then(res => {
      commit('setOutputdetail', res.data.data);
      commit('setOutputdetailIsLoading', false);
    }).catch(err => {
      console.log('error', err);
      commit('setOutputdetailIsLoading', false);
    });
}

export const storeOutputdetail = async ({ commit }, outputdetail) => {
  commit('setOutputdetailIsCreating', true);
  await connection.post(`/outputdetails/create`, outputdetail)
    .then(res => {
      commit('saveNewOutputdetails', res.data);
      commit('setOutputdetailIsCreating', false);
    }).catch(err => {
      console.log('error', err);
      commit('setOutputdetailIsCreating', false);
    });
}

export const storeMultipleOutputdetail = async ({ commit }, outputdetailsMultiple) => {
  commit('setOutputdetailIsCreating', true);
  commit('saveNewMultipleOutputdetails', false);
  await connection.post(`/outputdetails/create/multiple`, outputdetailsMultiple)
    .then(res => {
      const response = res.data == true ? true : false
      console.log(res.data);
      console.log(response);
      commit('saveNewMultipleOutputdetails', response);
      commit('setOutputdetailIsCreating', false);
    }).catch(err => {
      console.log('error', err);
      commit('setOutputdetailIsCreating', false);
    });
}

export const updateOutputdetail = async ({ commit }, outputdetail ) => {
  commit('setOutputdetailIsUpdating', true);
  await connection.put(`/outputdetails/${outputdetail.id}/update`, outputdetail)
    .then(res => {
      commit('saveUpdatedOutputdetail', res.data);
      commit('setOutputdetailIsUpdating', false);
    }).catch(err => {
      console.log('error', err);
      commit('setOutputdetailIsUpdating', false);
    });
}

export const deleteOutputdetail = async ({ commit }, outputdetail) => {
  commit('setOutputdetailIsDeleting', true);
  await connection.delete(`/outputdetails/${outputdetail.id}/delete`)
    .then(res => {
      commit('setDeleteOutputdetail', res.data);
      commit('setOutputdetailIsDeleting', false);
    }).catch(err => {
      console.log('error', err);
      commit('setOutputdetailIsDeleting', false);
    });
}
